"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
require("./styles.scss");
const LocationRelatedPages = (props) => {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ id: "whereToStart", className: "whereToStart sidebarBox" }, { children: [(0, jsx_runtime_1.jsxs)("header", { children: [(0, jsx_runtime_1.jsx)("h3", { children: props.title }), props.children] }), (0, jsx_runtime_1.jsx)("ul", { children: props.list.map((li, index) => ((0, jsx_runtime_1.jsx)("li", Object.assign({ id: li.id }, { children: (0, jsx_runtime_1.jsx)("a", Object.assign({ href: li.link }, { children: li.name })) }), `${li.id} ${index}`))) })] })));
};
exports.default = LocationRelatedPages;
